import type { IconData } from '@stacksjs/iconify-core'

export const arrowDownLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3.828 8.9h5.586a1 1 0 0 1 0 2h-8a.997.997 0 0 1-1-1v-8a1 1 0 1 1 2 0v5.585L9.192.707a1 1 0 1 1 1.415 1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowDownLeft
